import React, { useRef } from 'react'
import serialize from 'form-serialize'

import './newsletterSignup.css'
import arrowRight from '../../images/arrow-right.svg'

const NewsletterSignup = ({ data }) => {
  const formRef = useRef(null)
  const emailRef = useRef(null)
  const thanksRef = useRef(null)

  function encode(data) {
    return Object.keys(data)
      .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(data[key]))
      .join('&')
  }

  function handleSubmit(event) {
    event.preventDefault()
    const action = event.target.action
    const data = serialize(formRef.current)
    console.log(data)
    fetch(action, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: encode({
        'form-name': formRef.current.getAttribute('name'),
        email: emailRef.current.value,
      }),
    })
      .then(res => {
        if (res.ok) {
          formRef.current.classList.add('hidden')
          thanksRef.current.classList.remove('hidden')
        } else {
          throw Error(`Status --> ${res.status} status text --> ${res.statusText}`)
        }
      })
      .catch(error => {
        console.log('Form submission error -->', error)
      })
  }

  const config = {
    bgColor: data.config && data.config.bgColor ? data.config.bgColor : 'white',
    textColor: data.config && data.config.textColor ? data.config.textColor : 'black',
  }

  return (
    <section className={`newsletterSignup bg-${config.bgColor} text-${config.textColor}`}>
      <div className="inner">
        <div className="content">
          {data.title && <h2>{data.title}</h2>}
          {data.text && <p>{data.text}</p>}
        </div>
        <form
          data-netlify="true"
          netlify-honeypot="nameField"
          name="newsletterSignup"
          method="POST"
          action="/"
          onSubmit={handleSubmit}
          ref={formRef}
        >
          <input name="form-name" value="newsletterSignup" type="hidden" />
          <div className="name-field">
            <label htmlFor="nameField">Name</label>
            <input type="text" id="nameField" name="nameField" />
          </div>
          <div className="field">
            <input
              type="email"
              required={true}
              id="email"
              name="email"
              placeholder=" "
              ref={emailRef}
            />
            <label htmlFor="email">{data.label}</label>
          </div>
          <button type="submit">
            <img src={arrowRight} alt="submit" />
          </button>
        </form>
        <div className="thanks hidden" ref={thanksRef}>
          <p>
            Thanks for signing up. Look forward to a fresh dose of things that matter in your inbox
            every week!
          </p>
        </div>
      </div>
    </section>
  )
}

export default NewsletterSignup
